import { AmphitheatreButtonWrapper } from 'src/Components/CustomButton/AmphitheatreButtonWrapper';
import styled from 'styled-components';

export const Yellow = styled(AmphitheatreButtonWrapper)`
  > button {
    background-color: #ffc70b !important;
    border-color: #ffc70b !important;

    color: black;

    &:hover {
      background-color: #eba800 !important;
      border-color: #eba800 !important;
    }
  }
`;
